import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.MobileBusinesses = routerStyxie({ actions: ['index', 'new', 'show', 'edit', 'dashboard']})
